/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsMyGamesPublicAuthOptions interface.
 */
export function instanceOfFxIdDomainSettingsMyGamesPublicAuthOptions(value) {
    if (!('ClientId' in value) || value['ClientId'] === undefined)
        return false;
    if (!('GameCode' in value) || value['GameCode'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsMyGamesPublicAuthOptionsFromJSON(json) {
    return FxIdDomainSettingsMyGamesPublicAuthOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsMyGamesPublicAuthOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ClientId': json['ClientId'],
        'GameCode': json['GameCode'],
    };
}
export function FxIdDomainSettingsMyGamesPublicAuthOptionsToJSON(json) {
    return FxIdDomainSettingsMyGamesPublicAuthOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsMyGamesPublicAuthOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ClientId': value['ClientId'],
        'GameCode': value['GameCode'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsMyGamesPublicAuthOptions.js.map